export default __webpack_public_path__ + "static/media/send-task.7e836efa.png";